__turbopack_context__.v({
  "category_name": "TVvKGq_category_name",
  "container": "TVvKGq_container",
  "item": "TVvKGq_item",
  "item_info": "TVvKGq_item_info",
  "item_info_meta": "TVvKGq_item_info_meta",
  "item_info_name": "TVvKGq_item_info_name",
  "item_info_note": "TVvKGq_item_info_note",
  "item_info_organization": "TVvKGq_item_info_organization",
  "item_info_organization_url": "TVvKGq_item_info_organization_url",
  "item_info_tags": "TVvKGq_item_info_tags",
  "list": "TVvKGq_list",
  "title": "TVvKGq_title",
});
